import { z } from 'zod';
import { positionNameSchema } from './employment.js';
import { scopeSchema } from './scope.js';
/**
 * KADRLAR BAZASI — tizimga kirish huquqidan mustaqil xodimlar ro'yxati.
 *
 * Ikkisi ATAYLAB ajratilgan:
 *  - `personnel` — kadrlar bo'limidan kelgan 4700+ yozuv. Kira olmaydi,
 *    paroli yo'q, faqat qidiriladi.
 *  - `user` — tizimga kirish huquqi berilgan xodim. U kadrlar bazasidagi
 *    yozuvdan JSHSHIR bo'yicha "olib kelinadi" va unga rol beriladi.
 *
 * Ajratilmaganda har bir kadrlar yozuvi login va parolga ega bo'lardi:
 * 4700 ta hisobning 4600 tasi hech qachon ishlatilmasdi, lekin har biri
 * tizimga kirish nuqtasi bo'lib turardi.
 */
/** JSHSHIR — qat'iy 14 ta raqam. Boshqa uzunlik umuman qidirilmaydi. */
export const jshshirSchema = z
    .string()
    .trim()
    .regex(/^\d{14}$/, 'JSHSHIR 14 ta raqamdan iborat bo\'lishi kerak');
export const personnelLookupQuerySchema = z.object({ jshshir: jshshirSchema });
/**
 * Xodimni tizimga qo'shish.
 *
 * F.I.Sh, telefon, korxona va lavozim SO'ROVDA YO'Q — hammasi kadrlar
 * bazasidan olinadi. Aks holda administrator ismni qo'lda terib, kadrlar
 * ma'lumotidan farq qiladigan ikkinchi haqiqat yaratardi.
 */
export const createUserInputSchema = z.object({
    jshshir: jshshirSchema,
    roleId: z.string().regex(/^\d+$/),
    scope: scopeSchema,
    /**
     * Ish joyi — FAQAT kadrlar bazasida u bo'lmaganda.
     *
     * Yuqoridagi qoidaning istisnosi va u haqiqatdan kelib chiqadi: kadrlar
     * faylida 63 470 yozuvdan 37 471 tasida korxona umuman ko'rsatilmagan.
     * Ular uchun "hammasi kadrlar bazasidan olinadi" degan qoida javob
     * bermaydi — olinadigan narsa yo'q va xodim tizimga umuman kira olmasdi.
     *
     * Kadrlar bazasida ish joyi BOR bo'lsa bu maydonlar rad etiladi: ikkinchi
     * haqiqat yaratmaslik qoidasi o'z kuchida qoladi.
     */
    /**
     * KADRLAR BAZASIDA UMUMAN YO'Q xodim — ismi qo'lda teriladi.
     *
     * Yuqoridagi «hammasi kadrlar bazasidan» qoidasining ikkinchi istisnosi.
     * Sababi birinchisiniki bilan bir xil — haqiqat: kadrlar fayli hamma
     * odamni qamramaydi va qamragunicha o'sha xodim tizimga umuman kira
     * olmasdi.
     *
     * Ism berilsa yozuv `personnel` ga QO'SHILADI, jadval chetlab
     * o'tilmaydi: shuning uchun ikkinchi haqiqat yaratilmaydi va kadrlar
     * importi keyin o'sha JSHSHIR ni topib, rasmiy ma'lumot bilan ustiga
     * yozadi. Yozuv `is_manual` bilan belgilanadi — manba ko'rinib tursin.
     *
     * JSHSHIR bor bo'lsa bu maydonlar RAD ETILADI: yagona manba qoidasi
     * o'z kuchida.
     */
    fullName: z.string().trim().min(3, 'F.I.Sh juda qisqa').max(200).optional(),
    phone: z.string().trim().max(20).optional(),
    orgUnitId: z.string().regex(/^\d+$/).optional(),
    positionId: z.string().regex(/^\d+$/).optional(),
    /**
     * Lavozim QO'LDA yozilganda — `positionId` o'rniga nomi.
     *
     * Ish joyi ko'rsatilayotgan holat aynan ma'lumotnoma yetmaydigan holat:
     * kadrlar bazasida korxonasi yo'q xodim uchun ro'yxatdan mos lavozim
     * topish ehtimoli ham past. Server nomni tozalaydi va ma'lumotnomaga
     * qo'shadi (`PositionService.resolveByName`).
     */
    positionName: positionNameSchema.optional(),
    /**
     * BO'LINMA — korxona ichidagi bo'lim («R va AX», «TB»).
     *
     * Yuqoridagi ikkitasidan farqli: bu maydon kadrlar bazasida ish joyi BOR
     * bo'lganda ham qabul qilinadi. Sababi oddiy — DTIL da bo'lim degan
     * tushuncha umuman yo'q, ya'ni uni faqat administrator ko'rsatishi mumkin
     * va "ikkinchi haqiqat" yaratish xavfi yo'q.
     *
     * Bo'linma xodimning ISH JOYIGA tegishli bo'lishi tekshiriladi.
     */
    subdivisionId: z.string().regex(/^\d+$/).optional(),
})
    /* `positionId` va `positionName` birga kelmaydi — sabab `employment.ts` da. */
    .superRefine((value, ctx) => {
    if (value.positionId !== undefined && value.positionName !== undefined) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['positionName'],
            message: 'Lavozim yo ro\'yxatdan tanlanadi, yo qo\'lda yoziladi',
        });
    }
});
//# sourceMappingURL=personnel.js.map